import { instance } from './index'
import { insertKeyEndpoint } from './utils'

const SETTINGS = 'settings'

export const getSettings = (paramName: string) => {
  const param = new URLSearchParams()
  param.append('paramName', paramName)
  return instance.get(insertKeyEndpoint(SETTINGS) + '?' + param.toString())
}
